// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  width: 100%;
  overflow: hidden; /* Prevent scrolling */
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  justify-content: center;
  align-items: center; /* Optional: Center content */
}

#root {
  height: 100vh;
  width: 100vw;
  overflow: hidden; /* Ensures no scrollbars */
  display: flex; /* Optional: Control child elements */
}

button {
  font-family: inherit;
}

input,
select {
  font-family: inherit;
  outline: none;
}

input::placeholder {
  color: #9ca3af;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA;EACE,uGAAuG;EACvG,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAE,6BAA6B;AACpD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB,EAAE,0BAA0B;EAC5C,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml, body {\n  height: 100%;\n  width: 100%;\n  overflow: hidden; /* Prevent scrolling */\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: flex;\n  justify-content: center;\n  align-items: center; /* Optional: Center content */\n}\n\n#root {\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden; /* Ensures no scrollbars */\n  display: flex; /* Optional: Control child elements */\n}\n\nbutton {\n  font-family: inherit;\n}\n\ninput,\nselect {\n  font-family: inherit;\n  outline: none;\n}\n\ninput::placeholder {\n  color: #9ca3af;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
